import styled from "styled-components"; 


export const ContainerCardCheck = styled.div`
    width: 333px;
    height: 114px;
    min-height: 150px;
    border-radius: 16px;
    background: var(--color-white);
    box-shadow: 0px 41.7776px 33.4221px rgba(0, 0, 0, 0.0503198), 0px 22.3363px 17.869px rgba(0, 0, 0, 0.0417275), 0px 12.5216px 10.0172px rgba(0, 0, 0, 0.035), 0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725), 0px 2.76726px 2.21381px rgba(0, 0, 0, 0.0196802);
    border: ${({active}) => active ? "2px solid #FF6600": "2px solid #0000"};
    transition: ease-in-out 0.3s;
    margin: 20px;

    ${
        ({flgSoloConsulta}) => (
            flgSoloConsulta ? `

                 height: 160px;
            `: ""
        )
    }
`;

export const TopCardCheck = styled.div`
    width: 100;
    height: 45px;
    background:  var(--color-secondary-gradient);
    border-top-left-radius: 14px;
    border-top-right-radius: 14px;
    display: flex;
    align-items: center;
    gap: 10px; 
    h1 {
        margin: 0;
        padding: 0;
        padding-right: 10px;
        font-size: 18px;
        color: var(--color-white);
    }  
    .circle-orange {
        width: 24px;
        height: 24px;
        border-radius: 100%;
        background: ${({active})=> active ? "var(--color-primary)": "var(--color-white)"};
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
        transition: ease-in-out 0.3s;
    }
`;


export const BodyCardCheck = styled.div`
    width: 100%;
    height: calc(100% - 45px);
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    gap: 5px;
    padding: 0 6px;
    
`;